import {useParams} from "react-router-dom";
import styles from "./PPTInsertWaitingPage.module.css";
import Lottie from "react-lottie";
import {
    GO_BACK_POLLS_LINK,
    INSERTING_YOUR_ATTENDANCE, INSERTING_YOUR_ATTENDANCE_DESCRIPTION,
    INSERTING_YOUR_POLL, INSERTING_YOUR_POLL_DESCRIPTION,
    POLL_TYPE,
} from "../../utils/constants";
import React from "react";
import addingSlides from "./animations/addingSlides_PowerPoint.json";
import YuJaButton from "../../components/standardization/YuJaButton";
import {usePPTWebView} from "../../hooks/usePPTWebView";

export default function PPTInsertWaitingPage() {
    const { pollType } = useParams();
    const {goPollsPage} = usePPTWebView();


    const options = {
        loop: true,
        autoplay: true,
        animationData: addingSlides,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    };

    return (
        <div className={styles.container}>
            <div style={{flex: 1}}/>
            <Lottie
                options={options}
                height={260}
                width={260}
                isClickToPauseDisabled={true}
                style={{cursor: "default"}}
            />
            <span className={styles.title}>
                {pollType === POLL_TYPE.ATTENDANCE ? INSERTING_YOUR_ATTENDANCE : INSERTING_YOUR_POLL}

            </span>
            <div style={{height: 20}}/>
            <span className={styles.description}>
                {pollType === POLL_TYPE.ATTENDANCE
                    ? INSERTING_YOUR_ATTENDANCE_DESCRIPTION
                    : INSERTING_YOUR_POLL_DESCRIPTION
                }
            </span>
            <div style={{flex: 3}}/>
        </div>
    );
}